'use strict';

angular.module('substoreApp.services')
    .factory('$exceptionHandler', ['$injector', '$log', function ($injector, $log) {
        var $location;
        var sessionData;

        // make body visible (in case it is not already visible)
        function showBody() {
            if (self === top) {
                angular.element(document.querySelector('#bodymain')).css('display', 'inherit');
            } else {
                top.location = self.location;
            }
        }

        return function (exception, cause) {
            $location = $location || $injector.get('$location');
            sessionData = sessionData || $injector.get('sessionData');
            var targetRoute = "/error";

            // prepare arguments for error page to make exception displayable
            if (typeof exception === "object" && exception.code) {
                $log.info('exceptionHandler: handling error code exception object:');
                $log.info(exception);
                sessionData.fault = exception;
                if (exception.code === "EXPIRED_SESSION") {
                    // special case: session expired
                    sessionData.sessionId = null;
                } else if (exception.positiveError === true) {
                    // special case: positive error
                    targetRoute = "/processing";
                }
            } else {
                // we cannot determine what it is
                $log.error('exceptionHandler: unhandled Javascript exception:');
                $log.error(exception);
                if (cause) { $log.error('cause:'); $log.error(cause); }
                sessionData.fault = {
                    code: "JAVASCRIPT_EXCEPTION",
                    message: 'unhandled Javascript exception: ' + exception.toString(),
                    args: { 'exception': exception, stackTrace: exception.stack }
                };
            }

            if (exception.positiveError !== true && sessionData.fault.code) {
                targetRoute = "/error/" + sessionData.fault.code;
            }

            $location.path(targetRoute);
            showBody();
        };
    }])
    /**
     * Generic error handling method to be used by routes
     */
    .factory('throwServiceResponseFault', ["sessionData",  function(sessionData) {
        var throwServiceResponseFault = function (response) {
            if (response.data && response.data.head && response.data.head.fault) {
                sessionData.fault = response.data.head.fault;
                throw sessionData.fault;
            } else if (response.status != -1) { //Firefox triggers the onerror callback of any pending XHR when moving away of the current page (e.g. reloading), status -1 is returned
                                                // https://github.com/angular/angular.js/issues/14219
                // no fault from server
                throw {
                    code: "HTTP_" + response.status,
                    message: "HTTP service request failed with " + response.status + " on " + response.config.method + " " + response.config.url,
                    config: response.config
                };
            }
        };

        return throwServiceResponseFault;
    }]);